import React, { useState } from "react";

import { ConfirmProvider } from "material-ui-confirm";

import { Divider, Container } from "@material-ui/core";

import useStyles from "./styles";

import ProductMetalAdd from "./ProductMetalAdd";
import ProductMetalEdit from "./ProductMetalEdit";
import ProductMetalList from "./ProductMetalList";

const ShowProductMetal = ({ productMetals, setRefreshMetals }) => {
  const classes = useStyles();

  //used for choosing the right control for the action
  const actions = {
    list: "list",
    add: "add",
    update: "update",
  };

  const [action, setAction] = useState(actions.list);
  const [selectedMetal, setSelectedMetal] = useState();

  if (action === actions.list) {
    return (
      <Container justify="center">
        <div className={classes.toolbar} />
        <Divider></Divider>
        <p></p>
        <ProductMetalList
          productMetals={productMetals}
          actions={actions}
          setAction={setAction}
          selectedMetal={selectedMetal}
          setSelectedMetal={setSelectedMetal}
        ></ProductMetalList>
      </Container>
    );
  } else if (action === actions.add) {
    return (
      <ConfirmProvider>
        <Container justify="center">
          <div className={classes.toolbar} />
          <Divider></Divider>
          <ProductMetalAdd
            productMetals={productMetals}
            actions={actions}
            setAction={setAction}
            setRefreshMetals={setRefreshMetals}
          ></ProductMetalAdd>
        </Container>
      </ConfirmProvider>
    );
  } else if (action === actions.update) {
    return (
      <ConfirmProvider>
        <Container justify="center">
          <div className={classes.toolbar} />
          <Divider></Divider>
          <ProductMetalEdit
            productMetals={productMetals}
            actions={actions}
            setAction={setAction}
            setSelectedMetal={setSelectedMetal}
            selectedMetal={selectedMetal}
            setRefreshMetals={setRefreshMetals}
          ></ProductMetalEdit>
        </Container>
      </ConfirmProvider>
    );
  }
};

export default ShowProductMetal;
